import { render, staticRenderFns } from "./PageDiscounts.vue?vue&type=template&id=2eb05b1b&scoped=true&"
import script from "./PageDiscounts.vue?vue&type=script&lang=ts&"
export * from "./PageDiscounts.vue?vue&type=script&lang=ts&"
import style0 from "./PageDiscounts.vue?vue&type=style&index=0&id=2eb05b1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb05b1b",
  null
  
)

export default component.exports